'use client';

import { PageLayout } from '@ui/components/layouts';
import { text } from '@modules/dashboard/text';
import { PageContentLoading } from '@/src/components/PageContentLoading';
import { PageHeaderWithGardenSelector } from '@/src/components/PageHeaderWithGardenSelector';

import type { Id } from 'convex/_generated/dataModel';
import type { DashboardProps } from '@modules/dashboard/containers/dashboard_container';

export function Dashboard({ ...props }: DashboardProps) {
  if (props.isLoading) {
    return <PageContentLoading />;
  }

  return (
    <PageLayout maxWidth={1280}>
      <PageHeaderWithGardenSelector
        title={text.title}
        description={text.description}
        gardens={props.gardens}
        selectedGardenId={props.selectedGardenId}
        onGardenChange={(id) => props.onGardenChange(id as Id<'gardens'> | null)}
        gardenSelectLabel={text.gardenSelectLabel}
      />

      {props.dateWeatherWidget}

      <div className="flex flex-col">{props.seedWidget}</div>
    </PageLayout>
  );
}
